export class Assignee {
  
    displayName: string;
    id: string;
    organizationId?: string;
    type: AssigneeType;
  
    constructor(displayName: string, id: string, type: AssigneeType, organizationId: string) {
      this.displayName = displayName;
      this.id = id;
      this.organizationId = organizationId;
      this.type = type;
    }
  }
  
  export enum AssigneeType {
    Group,
    Organization,
    User
  }